<div class="app-search-results-sort-select">
  <label class="app-search-results-sort-select__label fw-bold">{{searchBoxInputTranslations.textSearchDealership}}</label>
    <div class="app-search-results-sort-select__select dropdown-container">
      <div class="search-input-container d-flex flex-row flex-nowrap">
        <div class="search-bar-wrap position-relative flex-fill">
          <mat-form-field class="d-flex p-0" appearance="outline">
            <input 
              #searchBoxInput
              matInput
              type="text"
              [matAutocomplete]="auto"
              [formControl]="buyerOeSearchPhraseControl"
              class="pt-2 w-100"
            />
            <button
              matIconButton
              matSuffix
              title="Clear search input"
              (click)="clearBuyerOeSearchPhrase()"
              type="button"
              tabindex="0"
              attr.aria-label="Clear dealership name"
              class="cleanIcon__trigger"
            >
            <mat-icon><i class="allycon-glyph-close" aria-hidden="true"></i></mat-icon>
            </button>
            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayDealerFn"
              [disableRipple]="true"
              (optionSelected)="onDealerSelected($event)"
            >
            @for (dealer of filteredDealers | async; track dealer) {
              <mat-option [value]="dealer">
                {{ dealer.oeDetails }}
              </mat-option>
            }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      <button
        class="btn btn-secondary search-input-container__search-btn"
        (click)="buyerOeNameSearch()"
        type="button"
        tabindex="0"
        attr.aria-label="Search by dealer"
      >
        {{searchBoxInputTranslations.textSearch}}
      </button>
    </div>
  </div>
</div>
